import { Host, h } from '@stencil/core';
export class AibaBinInit {
  constructor() {
    this.styles = undefined;
    this.handlers = undefined;
  }
  async componentDidLoad() {
    //initiate bin service - TBD
    if (this.handlers && this.handlers.handleBinInit) {
      await this.handlers.handleBinInit();
    }
  }
  render() {
    return (h(Host, null, this.styles && h("style", null, this.styles), this.Children));
  }
  static get is() { return "aiba-bin-init"; }
  static get properties() {
    return {
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=aiba-bin-init.js.map
